import React, { useState } from 'react';
import styled from 'styled-components';

import { getThemeMainCategory, InspirationMainCategoryDefinition, InspirationTheme } from '../../lib/inspiration';
import SideBarSubCategory from './SideBarSubCategory';

const SideBarMainCategory = ({ mainCat, selectedTheme, onThemeClick }: {
  mainCat: InspirationMainCategoryDefinition,
  selectedTheme?: InspirationTheme,
  onThemeClick: (theme: InspirationTheme) => void
}) => {
  const [open, setOpen] = useState(false);
  const isSelected = selectedTheme !== undefined && getThemeMainCategory(selectedTheme)?.id === mainCat.id;
  const isOpen = open || isSelected;

  return <Wrapper>
    <MainCat onClick={() => setOpen(!open)} $bold={isSelected}>
      {mainCat.label}
    </MainCat>
    {
      <Container $height={isOpen ? undefined : 0}>
        {
          mainCat.subCategories.map(
            (subCat) => <SideBarSubCategory
              key={subCat.id}
              subCat={subCat}
              selectedTheme={selectedTheme}
              onThemeClick={onThemeClick}
            />)
        }
      </Container>
    }
  </Wrapper>;
};

const Wrapper = styled.li`
  padding: 0;
  cursor: pointer;
  font-weight: normal;
`;

const MainCat = styled.div<{ $bold: boolean }>`
  ${({$bold}) => $bold ? 'font-weight: 700;' : ''}
  padding: 12px 16px;
`;

const Container = styled.ul<{ $height?: number }>`
  list-style-type: none;
  padding: 0;
  ${({$height}) => `height: ${$height}px;`}
  overflow: hidden;
`;

export default SideBarMainCategory;
